// extracted by mini-css-extract-plugin
module.exports = {"beneficios":"Benefits_beneficios__12564"};